import axios from "axios";

const endpoint_url = "/account/api/v1/users/online";

const get = (parameters) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, {
        params: {
          ...parameters
        }
      })
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const getOnlineEmployee = {
  get
};

export default getOnlineEmployee;
